import { render, staticRenderFns } from "./UpdateBillPayment.vue?vue&type=template&id=667e050e"
import script from "./UpdateBillPayment.vue?vue&type=script&lang=js"
export * from "./UpdateBillPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports